import { Map as ImmutableMap, isCollection } from 'immutable';
import { OnboardingData } from 'registration/types';

export const ensureImmutableMapNurseSpecialties = (
  nurseSpecialties: OnboardingData['nurseSpecialties']
) => {
  if (!nurseSpecialties) {
    return ImmutableMap<number, number | ''>();
  }

  if (isCollection(nurseSpecialties)) {
    return nurseSpecialties;
  }

  return ImmutableMap<number, number | ''>(
    Array.from(nurseSpecialties) as [number, number | ''][]
  );
};

export const ensureMapNurseSpecialties = (
  nurseSpecialties: OnboardingData['nurseSpecialties']
) => {
  if (!nurseSpecialties) {
    return new Map<number, string | number>();
  }

  if (isCollection(nurseSpecialties)) {
    nurseSpecialties.reduce(
      (agg, val, key) => agg.set(key, val),
      new Map<number, string | number>()
    );
  }

  return nurseSpecialties as Map<number, string | number>;
};
